import {metadaApi} from '@dms/api/base';

import {
  GetRegistrationPlateDecoderApiArg,
  GetRegistrationPlateDecoderApiArgSchema,
  GetRegistrationPlateDecoderApiResponse,
  GetRegistrationPlateDecoderApiResponseSchema,
} from './types';

const metadaRegistrationPlateDecoderApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getRegistrationPlateDecoder: build.query<
      GetRegistrationPlateDecoderApiResponse,
      GetRegistrationPlateDecoderApiArg
    >({
      query: (queryArg) => ({
        url: `/vehicle/v2/registration-plate-decoder/${encodeURIComponent(queryArg.registrationPlate)}`,
        queryArg,
      }),
      extraOptions: {
        requestSchema: GetRegistrationPlateDecoderApiArgSchema,
        responseSchema: GetRegistrationPlateDecoderApiResponseSchema,
      },
    }),
  }),
});

export const {useLazyGetRegistrationPlateDecoderQuery} = metadaRegistrationPlateDecoderApi;
